import React, { ReactNode } from 'react';
import { useMediaQuery, Box, Typography, Theme } from '@mui/material';

import { Row } from './row';

type Props = {
  label: ReactNode;
  value?: ReactNode;
  color: string;
  colorShape?: 'rectangle' | 'line';
  disableLineBreak?: boolean;
};

export const ChartLegendChip = ({
  label,
  value,
  color,
  colorShape = 'rectangle',
  disableLineBreak = false,
}: Props) => {
  const lg =
    disableLineBreak ||
    useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  return (
    <Row
      sx={{
        gap: 1,
        px: 1,
        py: 0.5,
        borderRadius: 1,
        bgcolor: ({ palette }) =>
          palette.mode === 'dark' ? 'background.paper' : '#F5F5F5',
      }}
    >
      <Box
        sx={{
          width: colorShape === 'rectangle' ? 12 : 12,
          height: colorShape === 'rectangle' ? 12 : 2,
          backgroundColor: color,
          borderRadius: 1,
        }}
      />
      <Typography variant="body1">
        {lg ? (
          <>
            {label}
            {typeof value !== 'undefined' && <>: {value}</>}
          </>
        ) : (
          <>
            {label}
            <br />
            {value}
          </>
        )}
      </Typography>
    </Row>
  );
};
